<template>

  <div class="modal-out">
    <div class="modal" style="width: auto;">

      <div class="modal-header">
        <div class="title">视频对讲</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="min-height: 300px;padding: 20px;">

        <div class="main-container">
          <div v-if="!showOcx">未安装插件</div>
          <div class="video-content">
            <div id="playWndPreview" ref="preview" class="playWnd-preview"></div>
          </div>
        </div>

      </div>


    </div>

  </div>
</template>

<script>
import Ocx from '../../../../utils/ocx.js'

import { timeStr, } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";

export default {
  name: 'HelloWorld',
  data () {
    return {
      title: '预览',
      titleNew: '预览',
      showOcx: false,
      el: 'playWndPreview',
      cacheCutList: [],
      artemisToken: '',
      artemisUrl: '',
      moduleIndex: 0,
      moduleIndexNew: 0,
      seekTime: '',
      showDialog: false,
      formLabelAlign: JSON.parse(localStorage.getItem('previewObj')) || {
        deviceType: 32,
        cameraType: 0,
        cameraName: 'G33181616',
        deviceSerial: 'G33181616',
        channum: 1,
        validateCode: 'NZVCPJ',
        ezvizToken: 'ar.3x2eg7s26a3q41lz28b8xy7l7uae1w1i-2h72d9ycj5-0kpcoh3-yx83guhhq',
        appKey: 'aff20cd31bfc421db69a83b5b039f4f7',
        talkIndexCode: ''
      },
      formLabelAlignNew: JSON.parse(localStorage.getItem('previewObjNew')) || {
        deviceType: 32,
        cameraType: 0,
        cameraName: '225664421',
        deviceSerial: '225664421',
        channum: 1,
        validateCode: '1234AB',
        ezvizToken: 'at.4b6nucamcsmroip48r4k2z2bdskspiqe-8s1p2y36fc-1ae9khw-r44uergns',
        appKey: '72b6b58db1824e1d889c443952727903',
        talkIndexCode: ''
      },
      formLabelAlignBack: JSON.parse(localStorage.getItem('playBackObj')) || {
        deviceType: 32,
        cameraType: 0,
        cameraName: '',
        deviceSerial: '',
        channum: 1,
        validateCode: '',
        ezvizToken: '',
        appKey: '',
        talkIndexCode: '',
        beginTime: '',
        endTime: ''
      },
      formLabelAlignBackNew: JSON.parse(localStorage.getItem('playBackObjNew')) || {
        deviceType: 32,
        cameraType: 0,
        cameraName: '',
        deviceSerial: '',
        channum: 1,
        validateCode: '',
        ezvizToken: '',
        appKey: '',
        talkIndexCode: '',
        beginTime: '',
        endTime: ''
      },
      common: {
        sessionId: '',
        playHandle: 0
      },

      callbackData: {},
      SnapPictureData: '',
      cacheCut: [],
      ocxPlayer: null,

      sn:'',
      yzm:'',
      tdh:'',
      deviceCameraCode:'',


    }
  },

  created() {

  },
  mounted() {

  },
  methods: {

    closeSelf() {
      this.ocxDestory();
      this.$emit("closeCameraPlus");
    },

    init3(sn,deviceCameraCode,yzm,tdh){

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceCamera/GetLoginToken",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        },
      }).then((response) => {
        console.log(response.data.data);
        if (response.data.error == 0) {

          let artemisToken = response.data.data.artemisToken;
          let strAuthorization = response.data.data.strAuthorization;
          let productCode = response.data.data.productCode;
          let projectId = response.data.data.projectId;

          let initForm = {
            artemisToken: artemisToken,
            artemisUrl: 'https://open.hikyun.com/artemis',
            productCode: productCode,
            projectId: projectId,
            strAuthorization: strAuthorization,
            keepLiveUrl: 'https://zh.hikyun.com',
            playRealAdaptiveLayou: 0,
            playBackAdaptiveLayou: 0
          };
          this.$store.commit('update', ['initDataCamera',initForm]);

          this.init2(sn,deviceCameraCode,yzm,tdh);

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });


    },

    init2(sn,deviceCameraCode,yzm,tdh){
      this.sn = sn;
      this.deviceCameraCode = deviceCameraCode;
      this.yzm = yzm;
      this.tdh = tdh;

      this.ocxPlayer = null;
      this.showOcx = true;

      this.init();

    },

    getAccessToken(){

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceCamera/GetAccessToken",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          deviceCameraCode:this.deviceCameraCode,
        },
      }).then((response) => {
        //console.log(response.data.data);
        if (response.data.error == 0) {

          this.accessToken = response.data.data.accessToken;
          this.appKey = response.data.data.appKey;

          this.formLabelAlign.cameraName = this.sn;
          this.formLabelAlign.deviceSerial = this.sn;
          this.formLabelAlign.validateCode = this.yzm;
          this.formLabelAlign.channum = this.tdh;
          this.formLabelAlign.ezvizToken = this.accessToken;
          this.formLabelAlign.appKey = this.appKey;

          this.Hik_StartPlayReal();

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


    //设置为一个窗口
    HikYun_SetPlayRealLayoutType () {
      this.ocxPlayer
          .request({
            funcName: 'HikYun_SetPlayRealLayoutType',
            arguments: {'layoutType':1}
          })
          .then((res) => {
            console.log(res)
          })
    },


    onSubmit (type) {
      if (type === 0) {
        localStorage.setItem('previewObj', JSON.stringify(this.formLabelAlign))
      } else {
        localStorage.setItem('previewObjNew', JSON.stringify(this.formLabelAlignNew))
      }
      this.$message({
        message: '预览操作输入框中数据已保存至缓存。',
        type: 'success'
      })
    },
    onSubmitBack (type) {
      if (type === 0) {
        localStorage.setItem('playBackObj', JSON.stringify(this.formLabelAlignBack))
      } else {
        localStorage.setItem('playBackObjNew', JSON.stringify(this.formLabelAlignBackNew))
      }
      this.$message({
        message: '回放操作输入框中数据已保存至缓存。',
        type: 'success'
      })
    },
    openNewWnd () {
      this.showDialog = true
    },
    Hik_SwitchPlayMode (type) {
      if (type === 0) {
        // let arr = []
        this.moduleIndex = this.moduleIndex === 0 ? 1 : 0
        this.title = this.moduleIndex === 0 ? '预览' : '回放'
        this.ocxPlayer
            .request({
              funcName: 'Hik_SwitchPlayMode',
              arguments: Object.assign(this.common, { moduleIndex: this.moduleIndex })
            })
            .then((res) => {
              console.log(res)
            })
      } else {
        this.moduleIndexNew = this.moduleIndexNew === 0 ? 1 : 0
        this.titleNew = this.moduleIndexNew === 0 ? '预览' : '回放'
        this.ocxPlayer
            .request({
              funcName: 'Hik_SwitchPlayMode',
              arguments: Object.assign(this.common, { moduleIndex: this.moduleIndexNew })
            })
            .then((res) => {
              console.log(res)
            })
      }
    },
    Hik_StopPlayReal () {
      this.ocxPlayer
          .request({
            funcName: 'Hik_StopPlayReal',
            arguments: this.common
          })
          .then((res) => {
            console.log(res)
          })
    },
    Hik_StopPlayBack () {
      this.ocxPlayer
          .request({
            funcName: 'Hik_StopPlayBack',
            arguments: this.common
          })
          .then((res) => {
            console.log(res)
          })
    },
    Hik_SeekPlayBack () {
      this.ocxPlayer
          .request({
            funcName: 'Hik_SeekPlayBack',
            arguments: Object.assign(this.common, {seekTime: this.seekTime})
          })
          .then((res) => {
            console.log(res)
          })
    },
    Hik_StartPlayBack () {
      let arr = []
      arr.push(this.formLabelAlignBack)
      this.ocxPlayer
          .request({
            funcName: 'Hik_StartPlayBack',
            arguments: {
              deviceList: arr
            }
          })
          .then((res) => {
            console.log(res)
          })
    },
    Hik_StartPlayReal () {
      let arr = []
      arr.push(this.formLabelAlign)
      this.ocxPlayer
          .request({
            funcName: 'Hik_StartPlayReal',
            arguments: {
              deviceList: arr
            }
          })
          .then((res) => {
            console.log(res)
          })
    },
    refresh () {
      this.reload()
    },
    ocxDestory () {
      this.ocxPlayer && this.ocxPlayer.close()
      this.ocxPlayer = null
    },
    init () {
      let that = this;
      this.ocxPlayer = new Ocx({
        el: that.el,
        dllPath: './VPMClient.dll',
        autoLoad: true,
        error: () => {
          console.info('webControl初始化失败。')
          that.showOcx = false;
        },
        afterCreateWnd (ocx) {
          console.info('webControl初始化成功。')
          console.log(ocx)

          //that.ocxPlayer.resize();//使窗口重新渲染
          that.HikYun_SetPlayRealLayoutType();//改变窗口数量
          that.getAccessToken();
          that.$nextTick(()=>{
            that.ocxPlayer.resize();
          });

        },
        callback: (data, ocx) => {
          console.log(data, ocx)
          that.callbackData = data.responseMsg
          that.SnapPictureData = 'data:image/png;base64,' + data.responseMsg.SnapPictureData
        }
      })
    },

  },
  beforeDestroy () {
    this.ocxDestory()
  }
}

</script>

<style scoped lang="scss">

.main-container {
  text-align: center;
  width: 100%;
}

.video-content {
  width: 800px;
  height: 500px;
  display: block;
  border: 1px solid #ccc;
  .playWnd-preview {
    width: 100%;
    height: 100%;
  }
}


</style>
